import { Generator } from '@element/oxygen';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default Generator.forAccess;
